import {createStore} from '@web/helpers/redux'

import {RootState} from '../interfaces'

import Middlewares, {DefaultMiddlewareOptions} from './middlewares'
import createRootReducer from './reducer'

const store = createStore<RootState>({
    rootReducerCreator: createRootReducer,
    middlewares: Middlewares,
    defaultMiddlewareOptions: DefaultMiddlewareOptions,
})

export default store
